import { NullableString, NullableNumber } from "../../../types/nullable-types";
import {IServiceFactory} from "../../service-factory.interface";
import {PassengerTypeCodesEnum} from "../passenger-type-codes.enum";
import {PassengerTypeBase} from "./passenger-type-base";

export class Dog extends PassengerTypeBase {
    constructor(services: IServiceFactory) {
        super(services, PassengerTypeCodesEnum.Dog);
    }

    public get implicitTitleValue(): NullableString {
        return null;
    }
    getMinimumAge(): number {
        return 0;
    }
    protected _getMaximumAge(): NullableNumber {
        return null;
    }
    get description(): string {
        return this.services.language.translate('Dog');
    }
    get canBeMadePrimaryContact(): boolean {
        return false;
    }
    get isAdult(): boolean {
        return false;
    }
    get isChild(): boolean {
        return false;
    }
    get isInfant(): boolean {
        return false;
    }

    get isDog(): boolean {
        return true;
    }

    get isDateOfBirthMandatory(): boolean {
        return false;
    }

}